import React, { useContext, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Input } from '@thd-olt-component-react/input';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import Field from '../../common/Field/Field';
import { jobPostingValidators } from '../../../utils/validations';

export const EditableJobPostingPayRange = observer(
  (
    {
      jpKey,
      label,
      type,
      value,
      errorText,
      maxLength,
      required
    }) => {
    const { activeJobPosting, updateJobPostingField } = useContext(JobPostingContext);

    const [dirty, setDirty] = useState(false);
    const [didError, setDidError] = useState(false);
    const [displayedAmount, setDisplayedAmount] = useState(() => {
      if (value === null || value === undefined) {
        return '$';
      }
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
    });

    function validate() {
      // check value in validation function
      return jobPostingValidators[jpKey](activeJobPosting);
    }

    const handleBlur = (displayedAmount, setDisplayedAmount) => {
      const numericValue = parseFloat(displayedAmount.replace(/[^0-9.]/g, ''));
      if (!Number.isNaN(numericValue)) {
        const displayedValue = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(numericValue);
        setDisplayedAmount(displayedValue);
      } else {
        setDisplayedAmount('$');
      }
    };

    function initFocus() {
      setDirty(true);
      setDidError(false);
    }

    return (
      <Field
        label={label}
        dirty={dirty}
        showError={didError}
        errorText={errorText}
        required={required}
      >
        <div className="ptp-job-posting__pay-range-div" data-testid={`job-posting-editor-${jpKey}`}>
          <Input
            required={required}
            type={type}
            validateOnBlur
            value={displayedAmount}
            {...maxLength && { maxLength }}
            onChange={(newValue) => {
              setDirty(true);
              const numericValue = parseFloat(newValue.replace(/[^0-9.]/g, ''));
              if (!Number.isNaN(numericValue)) {
                updateJobPostingField('payRange', { ...activeJobPosting.payRange, ...{ [jpKey]: numericValue } });
              } else {
                updateJobPostingField('payRange', { ...activeJobPosting.payRange, ...{ [jpKey]: '' } });
              }
              setDisplayedAmount(newValue);
            }}
            onBlur={() => handleBlur(displayedAmount, setDisplayedAmount)}
            onFocus={initFocus}
            validation={validate}
            errorText={errorText}
            name={jpKey}
          />
        </div>
      </Field>
    );
  }
);
